export class StagePosition {}
export class StageRotation {}
